export default "__VITE_ASSET__DSDRqUEX__"